import React from 'react';
// import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/styles';
import { createTheme } from '@material-ui/core';
import { NotificationContainer } from 'react-notifications';
import App from './App.js';
import './public/styles/main.scss';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './public/styles/fonts.scss';
import 'react-notifications/lib/notifications.css';

Bugsnag.start({
  apiKey: '5ba8ca4fe73d64cb9def6a08d8bae7c1',
  plugins: [new BugsnagPluginReact()],
  enabledReleaseStages: ['production'],
});
const theme = createTheme({
  palette: {
    primary: {
      main: '#01BFBD !important',
    },
  },
});

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);
  const rootElement = document.getElementById('app');
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
      <ErrorBoundary>
        <Router>
          <ThemeProvider theme={theme}>
            <NotificationContainer />
            <App />
          </ThemeProvider>
        </Router>
      </ErrorBoundary>
    );
  } else {
    console.error('Failed to find the root element');
  }
